// Re-export singleton implementation to prevent multiple GoTrueClient instances
export { createClient, getSupabaseClient } from './client-singleton'